import { createActionTypeModel } from "../../../store/global/action-model";
export * from "./groups/types";
export * from "./files/types";

export const ContactsData = createActionTypeModel('ContactsData');

export const SelectedContact = createActionTypeModel('SelectedContact');
export const SEARCH_CONTACTS = 'SEARCH_CONTACTS';
export const ADVANCED_SEARCH_CONTACTS = 'ADVANCED_SEARCH_CONTACTS';
export const ADVANCED_SEARCH_CREATE_GROUP = 'ADVANCED_SEARCH_CREATE_GROUP';

export const SelectedContactLoading = createActionTypeModel('SelectedContactLoading');
export const SelectedContactGroups = createActionTypeModel('SelectedContactGroup');
export const SelectedContactRelatedContacts = createActionTypeModel('SelectedContactRelatedContacts');

export const SET_CONTACT_FILES = 'SET_CONTACT_FILES';
export const SET_PROVIDER_DATA = 'SET_PROVIDER_DATA';

export const ContactFiles = createActionTypeModel('ContactFiles');
export const ContactFields = createActionTypeModel('ContactFields');
export const ContactAccountingInfo = createActionTypeModel('ContactAccountingInfo');
export const DELETE_PAYMENT_PROVIDER = 'DELETE_PAYMENT_PROVIDER';

export const SET_CONTACT_SEARCH_CONFIG = 'SET_CONTACT_SEARCH_CONFIG';
// export const SET_CONTACT_LIST_STARTROW = 'SET_CONTACT_LIST_STARTROW';

export const ContactDetails = createActionTypeModel('ContactDetails');